import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const LAUNCH_DATE = new Date("2027-02-11T23:59:59");

const COUNT_EPOCH = new Date("2026-09-20T00:00:00").getTime();

export const gardenCount = (realCount = 0) => {
    const days = Math.max(0, Math.floor((Date.now() - COUNT_EPOCH) / 86400000));
    return 18 + days * 2 + realCount;
};
